.otherBookieWrapper .otherBookies {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 8px;
}
